<template>
    <div id="app" :class="[lang]">
        <router-view />
        <!-- <div class="clear-token" @click="clearToken">清除登录</div>
        <div class="show-vconsole" @click="showConsole">显示调试器</div>
        <div class="bgm-btn" @click="playBgm">
            BGM {{ $store.state.bgmPlayState ? 'on' : 'off' }}
        </div>
        <div class="change-lang" @click="changelang">
            切换语言
        </div> -->
    </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import { urlParser, getQueryString } from '@/utils';
import { Bus } from '@/utils/eventBus.js';
import LS from '@/utils/storage.js';
import { LS_PREFIX } from '@/config';
import i18n from '@/lang';
export default {
    computed: {
        lang() {
            return this.$store.state.lang || 'en';
        }
    },
    methods: {
        ...mapActions([
            'getAuthLocation',
            'getUserInfo',
            'getToken',
            'getConfigs',
            'getTagList',
            'getStarList',
            'getDragonList',
            'getBattleList',
            'showComm'
        ]),
        ...mapMutations(['SET_STATE', 'SET_LANG']),
        async initBaseData() {
            await this.getConfigs();
            await this.getTagList();
            await this.getStarList();
            await this.getDragonList();
            await this.getBattleList();
            console.log('都请求完啦！开始初始化游戏实例');
        }
        // clearToken() {
        //     LS.remove(LS_PREFIX + 'token');
        //     location.reload();
        // },
        // showConsole() {
        //     new VConsole();
        // },
        // changelang() {
        //     const lang = this.$store.state.lang;
        //     console.log(lang);
        //     if (lang == 'en') {
        //         this.SET_LANG('ru');
        //         this.$i18n.locale = 'ru';
        //     } else {
        //         this.SET_LANG('en');
        //         this.$i18n.locale = 'en';
        //     }
        // },
        // playBgm() {
        //     let _bgmState = this.$store.state.bgmPlayState;
        //     let _volume = this.$store.state.bgmVolume;
        //     if (!_bgmState) {
        //         createjs.Sound.play('bgm', {
        //             loop: -1,
        //             volume: _volume
        //         });
        //     } else {
        //         createjs.Sound.stop();
        //     }

        //     // 更新BGM播放状态
        //     this.SET_STATE({
        //         key: 'bgmPlayState',
        //         val: !_bgmState
        //     });
        // }
    },
    created() {
        // // 未授权流程   无code
        // const myurl = urlParser(location.href);
        // const code = myurl.data('code');
        // const channel = myurl.data('channel');
        // console.log(code, channel);
        // if (code && channel) {
        //     this.initBaseData();
        //     this.getToken({
        //         channel,
        //         code,
        //         redirect_uri:
        //             'https://cdn.modiarts.com/2021/other/event/authCallback.html'
        //     });
        // } else {
        //     // 未登录
        //     // Bus.$emit('_goPage', 'start');
        // }
    }
};
</script>

<style lang="less">
@font-face {
    font-family: 'Dotted Songti Square';
    src: url('./assets/font/DOTTEDSONGTISQUAREREGULAR.woff') format('woff');
}
@font-face {
    font-family: 'silver';
    src: url('./assets/font/SILVER.woff') format('woff');
}
html,
body {
    width: 100%;
    height: 100%;
    overflow: hidden;
}
#app {
    width: 100%;
    height: 100%;
    position: relative;

    &.en {
        font-family: 'Dotted Songti Square';
    }

    &.ru {
        font-family: 'silver';
    }

    .clear-token {
        width: 100px;
        height: 30px;
        background: #fff;
        font-size: 20px;
        line-height: 30px;
        text-align: center;
        position: absolute;
        right: 10px;
        top: 10px;
    }

    .show-vconsole {
        width: 150px;
        height: 30px;
        background: #fff;
        font-size: 20px;
        line-height: 30px;
        text-align: center;
        position: absolute;
        right: 150px;
        top: 10px;
    }

    .bgm-btn {
        width: 150px;
        height: 30px;
        background: #fff;
        font-size: 20px;
        line-height: 30px;
        text-align: center;
        position: absolute;
        right: 350px;
        top: 10px;
    }

    .change-lang {
        width: 120px;
        height: 30px;
        background: #fff;
        font-size: 20px;
        line-height: 30px;
        text-align: center;
        position: absolute;
        left: 30px;
        top: 10px;
    }
}
</style>
